import React from "react";

const IArrowShortail = ({
  color = "#FAFAFA",
  width = "13",
  height = "13",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M10.5025 0.186827C10.8298 -0.0801354 11.3126 -0.0609572 11.6178 0.244118L12.4797 1.1061C12.8051 1.43153 12.8051 1.95905 12.4797 2.28448L2.28442 12.4798C1.95899 12.8052 1.43146 12.8052 1.10603 12.4798L0.244053 11.6178C-0.0813514 11.2924 -0.0813504 10.7649 0.244053 10.4394L10.4394 0.244118L10.5025 0.186827ZM1.06892 11.0286L1.69522 11.6549L11.6549 1.69529L11.0286 1.06899L1.06892 11.0286Z"
        fill={color}
      />
      <path
        d="M9.69522 4.36196L8.36189 3.02862L3.02856 8.36196L4.36189 9.69529L9.69522 4.36196Z"
        fill={color}
      />
      <path
        d="M5.36189 3.02862V0.361957C5.36189 0.177862 5.51113 0.0286234 5.69522 0.0286234C5.87932 0.0286234 6.02856 0.177862 6.02856 0.361957V3.02862C6.02856 3.21272 5.87932 3.36196 5.69522 3.36196C5.51113 3.36196 5.36189 3.21272 5.36189 3.02862Z"
        fill={color}
      />
      <path
        d="M10.0286 10.362V6.36196C10.0286 6.17786 10.1778 6.02862 10.3619 6.02862C10.546 6.02862 10.6952 6.17786 10.6952 6.36196V10.362C10.6952 10.5461 10.546 10.6953 10.3619 10.6953C10.1778 10.6953 10.0286 10.5461 10.0286 10.362Z"
        fill={color}
      />
      <path
        d="M0.695224 3.02862V1.69529C0.695224 1.5112 0.844463 1.36196 1.02856 1.36196C1.21265 1.36196 1.36189 1.5112 1.36189 1.69529V3.02862C1.36189 3.21272 1.21265 3.36196 1.02856 3.36196C0.844463 3.36196 0.695224 3.21272 0.695224 3.02862Z"
        fill={color}
      />
      <path
        d="M3.26426 5.06906L2.32145 4.12625C2.19128 3.99608 2.19128 3.78502 2.32145 3.65485C2.45163 3.52468 2.66268 3.52468 2.79286 3.65485L3.73566 4.59766C3.86584 4.72783 3.86584 4.93889 3.73566 5.06906C3.60549 5.19924 3.39443 5.19924 3.26426 5.06906Z"
        fill={color}
      />
      <path
        d="M7.02856 1.36196C7.21265 1.36196 7.36189 1.5112 7.36189 1.69529C7.36189 1.87938 7.21265 2.02862 7.02856 2.02862H4.36189C4.1778 2.02862 4.02856 1.87938 4.02856 1.69529C4.02856 1.5112 4.1778 1.36196 4.36189 1.36196H7.02856Z"
        fill={color}
      />
      <path
        d="M12.3619 8.02862C12.546 8.02862 12.6952 8.17786 12.6952 8.36196C12.6952 8.54605 12.546 8.69529 12.3619 8.69529H8.36189C8.1778 8.69529 8.02856 8.54605 8.02856 8.36196C8.02856 8.17786 8.1778 8.02862 8.36189 8.02862H12.3619Z"
        fill={color}
      />
      <path
        d="M1.69522 2.02862C1.87932 2.02862 2.02856 2.17786 2.02856 2.36196C2.02856 2.54605 1.87932 2.69529 1.69522 2.69529H0.361891C0.177796 2.69529 0.0285578 2.54605 0.0285578 2.36196C0.0285578 2.17786 0.177796 2.02862 0.361891 2.02862H1.69522Z"
        fill={color}
      />
      <path
        d="M3.26426 3.65485C3.39443 3.52468 3.60549 3.52468 3.73566 3.65485C3.86584 3.78502 3.86584 3.99608 3.73566 4.12625L2.79286 5.06906C2.66268 5.19924 2.45163 5.19924 2.32145 5.06906C2.19128 4.93889 2.19128 4.72783 2.32145 4.59766L3.26426 3.65485Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowShortail;
